import { Button, MenuItem, SelectChangeEvent } from "@mui/material";
import { Select } from "@mui/material";
import { Grid, Paper } from "@mui/material";
import { CustomDisclaimerDialogPropsType } from "../../../../../../../types/dialogProps.types";
import CustomEnrollmentDisclaimerDialog from "../../../../../../shared/dialogs/customEnrollmentDisclaimerDialog/customEnrollmentDisclaimerDialog";
import { VEBToGeneralCoverageCodeType, VEB_TO_GENERAL_COVERAGE_CODE } from "../../../../../../../constants/coverage";
import {
	AuthContext,
	EligibleDependentContext,
	EnrollmentContext,
	GroupOwnerContext,
	PaycheckContext,
	ThemeContext
} from "../../../../../../../contexts";
import { LazyCustomFormDialog, LazyPlanActions, VEBDisclaimer } from "../../../../../../shared";
import { Checkbox } from "@mui/material";
import { useState, useCallback, useContext, useEffect, useMemo, Suspense, useRef } from "react";
import {
	AccidentDocAndRxPlanDetails,
	AccidentPlanCoverage,
	AccidentPlanCoverageLevel,
	AccidentPlanDetails,
	AccidentPremiumBenefit,
	AccidentRiderPlanCoverage,
	AccidentRiderPlanDetails,
	PaycheckFrequency,
	VEBPlan
} from "../../../../../../../types/plan.types";
import { CustomInput, CustomSelectInput } from "../../../../../../shared/CustomInput";
import {
	getKemperAccidentEligibleDependents,
	getKemperCancerEligibleDependents
} from "../../../../../../../utils/commonFunctions/VEBEnrollment/eligibleDependents";
import { Member } from "../../../../../../../types/employee.types";
import { GroupOwner } from "../../../../../../../types/groupOwner.types";
import { VEBPlanFormProps } from "../../../../../../../types/components/enrollmentProps.types";
import VEBPlanHeader from "../../../../../../shared/enrollment/VEBPlanHeader/PlanHeader";
import { dateTimeZoneConverter, getFirstOfNextMonth } from "../../../../../../../utils/commonFunctions/date";
import { dollarize } from "../../../../../../../utils/commonFunctions/dollarize";

import "./accidentForm.css";
import initCapitalize from "../../../../../../../utils/commonFunctions/initCapitalize";
import { VEBEnrollments, VEBEnrollmentSchema } from "../../../../../../../types/enrollment.types";
import {
	generateActivateVEBEnrollmentPayload,
	generateCancerKemperWaiveEnrollmentPayload
} from "../../../../../../../utils/commonFunctions/VEBEnrollment/enrollment";
import { VEBEnrollmentPayload } from "../../../../../../../utils/api/enrollment/enrollment";
import { api } from "../../../../../../../utils/api";
import { useHistory, useLocation } from "react-router-dom";
import { VEB_PLAN_NAME, VEB_PLAN_NAMES } from "../../../../../../../constants/plan";
import { CustomFormDialogType } from "../../../../../../../types/components/dialogProps.types";
import EnrollmentDependencyDialog from "../../cancer/dependencyDialog/EnrollmentDependencyDialog";
import Tooltip from "@mui/material/Tooltip";
import { AccidentPlanInitQuery } from "../../../../../../../utils/api/pages/enrollmentInit";
import { trackPromise } from "react-promise-tracker";
import { EligiblityDialogProps } from "../../../../../../../types/components/eligiblityDialogProps.types";
import EligiblityDialog from "../../../../eligiblityDialogs/EligiblityDialog";
import { VEBPlanCodes2024 } from "../../../../../../../constants/VEBPlanCodes/VEBPlanCodes2024";
import { VEBYearlyOpenAndCurrentEffectiveDate } from "../../../../../../../constants/VEBYearlyOpenAndCurrentDate";
import ExistsDependentModelVEB from "../../../../../../shared/existsMemberModel/ExistsDependentModelVEB";

const KemperAccidentForm = ({
	VEBOpenEnrollment,
	dependents,
	getVEBEnrollmentInitData
}: VEBPlanFormProps): JSX.Element => {
	const [writingNumber, setWritingNumber] = useState(1408);
	const [planCode, setPlanCode] = useState<string>();
	const [VEBOpenEnrollmentId, setVEBOpenEnrollmentId] = useState<string>();
	const [accidentPlan, setAccidentPlan] = useState<VEBPlan>({
		_id: "",
		plan_name: "",
		plan_code: "",
		start_date: null,
		end_date: null,
		status: ""
	});
	const [maxBenefitAmounts, setMaxBenefitAmounts] = useState<number[]>([]);
	const [docAndRxPlan, setDocAndRxPlan] = useState<VEBPlan>({
		_id: "",
		plan_name: "",
		plan_code: "",
		start_date: null,
		end_date: null,
		status: ""
	});
	const [eligibleDependents, setEligibleDependents] = useState<Member[]>([]);
	const [enrollmentDependencyDialogProps, setEnrollmentDependencyDialogProps] = useState({
		openDialog: false,
		content:
			"You are ineligible for Accident Disablity Riders as you have already enrolled for MedMutual Protect Short Term Disablity",
		actions: [
			{
				label: "Proceed without Disablity Rider",
				name: "Proceed without Disablity Rider",
				callback: () => {
					setEnrollmentDependencyDialogProps(
						Object.assign({}, enrollmentDependencyDialogProps, { openDialog: false })
					);
				}
			},
			{
				label: "Waive Short Term Disablity",
				name: "Waive Short Term Disablity",
				callback: () => {
					history.push("?step=Short%20Term%20Disability&stage=1&from=Accident");
				}
			}
		]
	});
	const [emailDisclaimer, setEmailDisclaimer] = useState("");
	const [hasReadTC, setHasReadTC] = useState(false);
	const [isActivelyWorking, setIsActivelyWorking] = useState(false);
	const [isDependentExistsModelOpen, setIsDependentExistsModelOpen] = useState(false);
	const [existsDependentData, setExistsDependentData] = useState<any>(null);
	const isDependentExistsModelOpenRef = useRef(false);
	const { groupOwner } = useContext(GroupOwnerContext);
	const { paycheck } = useContext(PaycheckContext);
	const { member } = useContext(AuthContext);
	const { eligiblity, setEligiblity } = useContext(EligibleDependentContext);
	const [docAndRx, setDocAndRx] = useState<AccidentDocAndRxPlanDetails>({
		standard_premium: {
			WEEKLY: 1.16,
			MONTHLY: 1.16
		}
	});
	const [enrollmentDisclaimerDialogProps, setEnrollmentDisclaimerDialogProps] =
		useState<CustomDisclaimerDialogPropsType>({
			openDialog: false,
			title: "Disclaimer",
			content:
				"Accident Indemnity: I hereby apply to Reserve National Insurance Company for a certificate to be issued in reliance on my written answers to the foregoing questions. All statements and answers are complete and true to the best of my knowledge and belief. FRAUD WARNING: Any person who knowingly presents a false or fraudulent claim for the payment of a loss is guilty of a crime and may be subject to fines and confinement in state prison.",
			importantTitle: "IMPORTANT",
			importantContent:
				"If an individual is insured under this policy and is also covered by Medicaid or a state variation of Medicaid, most non-disability benefits are automatically assigned according to state regulations.  This means that instead of paying the benefits to the insured individual, we must pay the benefits to Medicaid or the medical provider to reduce the charges billed to Medicaid.  Please consider your circumstances before enrolling in Kemper Benefits coverage.",
			inputFields: [
				{
					name: "Email Discalimer",
					value: emailDisclaimer,
					placeholder: "Enter Email"
				}
			],
			actions: [
				{
					label: "Email Disclaimer",
					callback: () => {
						null;
						// setEnrollmentDisclaimerDialogProps(
						// 	Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false })
						// );
					}
				}
			]
		});

	const [riderPlanDetails, setRiderPlanDetails] = useState<AccidentRiderPlanDetails>({
		rider_type: ["Accident Only", "Accident and Sickness"],
		monthly_benefit: [
			100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900,
			2000
		],
		standard_premium: {
			"Accident Only": {
				WEEKLY: [
					{
						coverageAmount: 100,
						premiumAmount: 0.22
					},
					{
						coverageAmount: 200,
						premiumAmount: 0.44
					},
					{
						coverageAmount: 300,
						premiumAmount: 0.66
					},
					{
						coverageAmount: 400,
						premiumAmount: 0.89
					},
					{
						coverageAmount: 500,
						premiumAmount: 1.11
					},
					{
						coverageAmount: 600,
						premiumAmount: 1.33
					},
					{
						coverageAmount: 700,
						premiumAmount: 1.55
					},
					{
						coverageAmount: 800,
						premiumAmount: 1.77
					},
					{
						coverageAmount: 900,
						premiumAmount: 1.99
					},
					{
						coverageAmount: 1000,
						premiumAmount: 2.22
					},
					{
						coverageAmount: 1100,
						premiumAmount: 2.44
					},
					{
						coverageAmount: 1200,
						premiumAmount: 2.66
					},
					{
						coverageAmount: 1300,
						premiumAmount: 2.88
					},
					{
						coverageAmount: 1400,
						premiumAmount: 3.1
					},
					{
						coverageAmount: 1500,
						premiumAmount: 3.32
					},
					{
						coverageAmount: 1600,
						premiumAmount: 3.54
					},
					{
						coverageAmount: 1700,
						premiumAmount: 3.77
					},
					{
						coverageAmount: 1800,
						premiumAmount: 3.99
					},
					{
						coverageAmount: 1900,
						premiumAmount: 4.21
					},
					{
						coverageAmount: 2000,
						premiumAmount: 4.43
					}
				],
				MONTHLY: [
					{
						coverageAmount: 100,
						premiumAmount: 0.96
					},
					{
						coverageAmount: 200,
						premiumAmount: 1.92
					},
					{
						coverageAmount: 300,
						premiumAmount: 2.88
					},
					{
						coverageAmount: 400,
						premiumAmount: 3.84
					},
					{
						coverageAmount: 500,
						premiumAmount: 4.8
					},
					{
						coverageAmount: 600,
						premiumAmount: 5.76
					},
					{
						coverageAmount: 700,
						premiumAmount: 6.72
					},
					{
						coverageAmount: 800,
						premiumAmount: 7.68
					},
					{
						coverageAmount: 900,
						premiumAmount: 8.64
					},
					{
						coverageAmount: 1000,
						premiumAmount: 9.6
					},
					{
						coverageAmount: 1100,
						premiumAmount: 10.56
					},
					{
						coverageAmount: 1200,
						premiumAmount: 11.52
					},
					{
						coverageAmount: 1300,
						premiumAmount: 12.48
					},
					{
						coverageAmount: 1400,
						premiumAmount: 13.44
					},
					{
						coverageAmount: 1500,
						premiumAmount: 14.4
					},
					{
						coverageAmount: 1600,
						premiumAmount: 15.36
					},
					{
						coverageAmount: 1700,
						premiumAmount: 16.32
					},
					{
						coverageAmount: 1800,
						premiumAmount: 17.28
					},
					{
						coverageAmount: 1900,
						premiumAmount: 18.24
					},
					{
						coverageAmount: 2000,
						premiumAmount: 19.2
					}
				]
			},
			"Accident and Sickness": {
				WEEKLY: [
					{
						coverageAmount: 100,
						premiumAmount: 0.98
					},
					{
						coverageAmount: 200,
						premiumAmount: 1.95
					},
					{
						coverageAmount: 300,
						premiumAmount: 2.93
					},
					{
						coverageAmount: 400,
						premiumAmount: 3.9
					},
					{
						coverageAmount: 500,
						premiumAmount: 4.88
					},
					{
						coverageAmount: 600,
						premiumAmount: 5.86
					},
					{
						coverageAmount: 700,
						premiumAmount: 6.83
					},
					{
						coverageAmount: 800,
						premiumAmount: 7.81
					},
					{
						coverageAmount: 900,
						premiumAmount: 8.79
					},
					{
						coverageAmount: 1000,
						premiumAmount: 9.76
					},
					{
						coverageAmount: 1100,
						premiumAmount: 10.74
					},
					{
						coverageAmount: 1200,
						premiumAmount: 11.71
					},
					{
						coverageAmount: 1300,
						premiumAmount: 12.69
					},
					{
						coverageAmount: 1400,
						premiumAmount: 13.67
					},
					{
						coverageAmount: 1500,
						premiumAmount: 14.64
					},
					{
						coverageAmount: 1600,
						premiumAmount: 15.62
					},
					{
						coverageAmount: 1700,
						premiumAmount: 16.59
					},
					{
						coverageAmount: 1800,
						premiumAmount: 17.57
					},
					{
						coverageAmount: 1900,
						premiumAmount: 18.55
					},
					{
						coverageAmount: 2000,
						premiumAmount: 19.52
					}
				],
				MONTHLY: [
					{
						coverageAmount: 100,
						premiumAmount: 4.23
					},
					{
						coverageAmount: 200,
						premiumAmount: 8.46
					},
					{
						coverageAmount: 300,
						premiumAmount: 12.69
					},
					{
						coverageAmount: 400,
						premiumAmount: 16.92
					},
					{
						coverageAmount: 500,
						premiumAmount: 21.15
					},
					{
						coverageAmount: 600,
						premiumAmount: 25.38
					},
					{
						coverageAmount: 700,
						premiumAmount: 29.61
					},
					{
						coverageAmount: 800,
						premiumAmount: 33.84
					},
					{
						coverageAmount: 900,
						premiumAmount: 38.07
					},
					{
						coverageAmount: 1000,
						premiumAmount: 42.3
					},
					{
						coverageAmount: 1100,
						premiumAmount: 46.53
					},
					{
						coverageAmount: 1200,
						premiumAmount: 50.76
					},
					{
						coverageAmount: 1300,
						premiumAmount: 54.99
					},
					{
						coverageAmount: 1400,
						premiumAmount: 59.22
					},
					{
						coverageAmount: 1500,
						premiumAmount: 63.45
					},
					{
						coverageAmount: 1600,
						premiumAmount: 67.68
					},
					{
						coverageAmount: 1700,
						premiumAmount: 71.91
					},
					{
						coverageAmount: 1800,
						premiumAmount: 76.14
					},
					{
						coverageAmount: 1900,
						premiumAmount: 80.37
					},
					{
						coverageAmount: 2000,
						premiumAmount: 84.6
					}
				]
			}
		}
	});
	const [accidentPlanDetails, setAccidentPlanDetails] = useState<AccidentPlanDetails>({
		coverage: [],
		coverage_level: ["Edge Enhanced", "Edge Premier"] as any,
		premium_amount: {
			standard_premium: {
				"Employee Only": {
					"Edge Enhanced": {
						WEEKLY: 3.82,
						MONTHLY: 16.55
					},
					"Edge Premier": {
						WEEKLY: 6.07,
						MONTHLY: 26.3
					},
					"Edge Value": {
						WEEKLY: 1.94,
						MONTHLY: 8.41
					},
					"Edge Premier+": {
						WEEKLY: 6.92,
						MONTHLY: 29.99
					}
				},
				"Employee & Spouse": {
					"Edge Enhanced": {
						WEEKLY: 8.08,
						MONTHLY: 35.01
					},
					"Edge Premier": {
						WEEKLY: 12.8,
						MONTHLY: 55.47
					},
					"Edge Value": {
						WEEKLY: 4.16,
						MONTHLY: 18.03
					},
					"Edge Premier+": {
						WEEKLY: 14.95,
						MONTHLY: 64.78
					}
				},
				"Employee & Children": {
					"Edge Enhanced": {
						WEEKLY: 8.08,
						MONTHLY: 35.01
					},
					"Edge Premier": {
						WEEKLY: 12.8,
						MONTHLY: 55.47
					},
					"Edge Value": {
						WEEKLY: 4.16,
						MONTHLY: 18.03
					},
					"Edge Premier+": {
						WEEKLY: 14.95,
						MONTHLY: 64.78
					}
				},
				"Employee & Family": {
					"Edge Enhanced": {
						WEEKLY: 8.08,
						MONTHLY: 35.01
					},
					"Edge Premier": {
						WEEKLY: 12.8,
						MONTHLY: 55.47
					},
					"Edge Value": {
						WEEKLY: 4.16,
						MONTHLY: 18.03
					},
					"Edge Premier+": {
						WEEKLY: 14.95,
						MONTHLY: 64.78
					}
				}
			}
		}
	});
	const [accidentPlanInputs, setAccidentPlanInputs] = useState<{
		coverage: null | string;
		coverage_level: null | string;
		rider_type: null | "Accident Only" | "Accident and Sickness";
		rider_benefit_amount: null | string;
	}>({
		coverage: null,
		coverage_level: null,
		rider_type: null,
		rider_benefit_amount: null
	});
	const [hasPreviousAccidentEnrollment, setHasPreviousAccidentEnrollment] = useState<boolean | null>(null);
	const [accidentSubPlans, setAccidentSubPlans] = useState<string[]>([]);
	const [hasSTDEnrollment, setHasSTDEnrollment] = useState<boolean | null>(null);
	const [waiveReason, setWaiveReason] = useState("");
	const [prevWritingNumber, setPrevWritingNumber] = useState(1408);
	const [showWritingNumberValidateButton, setShowWritingNumberValidateButton] = useState(false);
	const { theme } = useContext(ThemeContext);
	const location = useLocation();
	const history = useHistory();
	const [standardPremium, setStandardPremium] = useState(0);
	const [riderPremium, setRiderPremium] = useState(0);
	const [hasSelectedRider, setHasSelectedRider] = useState<boolean>(false);
	const [docAndRxPremium, setDocAndRxPremium] = useState(0);
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const { setCurrentEnrollment, deleteCurrentEnrollment } = useContext(EnrollmentContext);
	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();
	const [eligiblityDialogProps, setEligiblityDialogProps] = useState<any>({
		openDialog: false,
		handleCloseEligiblityDialog: () =>
			setEligiblityDialogProps(
				Object.assign({}, eligiblityDialogProps, {
					openDialog: false
				})
			),
		eligibleDependents: [],
		ineligibleDependents: [],
		ineligibleRelationshipDependents: [],
		VEBPlanName: "Accident"
	});

	const getVEBPlanCode = useCallback((VEBOpenEnrollment: any[]) => {
		// // console.log("**********VEBOpenEnrollment********", VEBOpenEnrollment[0]);
		let _planCode, _VEBOpenEnrollmentId;
		for (let idx = 0; idx < VEBOpenEnrollment.length; idx++) {
			const planName = VEBOpenEnrollment[idx].open_enrollment.veb_plan_name;
			const planCode = VEBOpenEnrollment[idx].open_enrollment.veb_plan_code;
			const VEBPlanId = VEBOpenEnrollment[idx].open_enrollment.veb_plan_id;
			const VEBOpenEnrollmentId = VEBOpenEnrollment[idx].VEB_open_enrollment_id;
			// // console.log("<====Plan Name===>", planName);

			if (planName === VEB_PLAN_NAMES.accident) {
				_planCode = planCode;
				_VEBOpenEnrollmentId = VEBOpenEnrollmentId;

				const _planPaylaod = {
					_id: VEBPlanId,
					plan_name: planName,
					plan_code: _planCode,
					start_date: null,
					end_date: null,
					status: "ACTIVE"
				};

				setAccidentPlan(Object.assign({}, _planPaylaod));
			}
			if (planName === VEB_PLAN_NAMES.doc_and_rx) {
				const DocAndRxPlanName = VEBOpenEnrollment[idx].open_enrollment.veb_plan_name;
				const DocAndRxPlanCode = VEBOpenEnrollment[idx].open_enrollment.veb_plan_code;
				const VEBDocAndRxPlanId = VEBOpenEnrollment[idx].open_enrollment.veb_plan_id;

				const _planDocAndRxPaylaod = {
					_id: VEBDocAndRxPlanId,
					plan_name: DocAndRxPlanName,
					plan_code: DocAndRxPlanCode,
					start_date: null,
					end_date: null,
					status: "ACTIVE"
				};

				setDocAndRxPlan(Object.assign({}, _planDocAndRxPaylaod));
			}
		}

		setPlanCode(_planCode);
		setVEBOpenEnrollmentId(_VEBOpenEnrollmentId);
	}, []);

	const handleWaiveReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setWaiveReason(value);
	};

	const handleAccidentFormChange = (event: SelectChangeEvent) => {
		const { name, value } = event.target as HTMLSelectElement;

		setAccidentPlanInputs(
			Object.assign({}, accidentPlanInputs, {
				[name]: name === "rider_type" && value === "" ? null : value
			})
		);
	};

	const handleWritingNumberChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { value } = event.target as HTMLInputElement;
			setWritingNumber(Number(value));
			if (Number(value) !== prevWritingNumber) {
				setShowWritingNumberValidateButton(true);
			} else {
				setShowWritingNumberValidateButton(false);
			}
		},
		[prevWritingNumber]
	);

	const handleAgreedTCCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setHasReadTC(checked);
	};

	const handleIsActivelyWorkingCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setIsActivelyWorking(checked);
	};

	const handleOpenDisclaimerDialogClick = useCallback(() => {
		setEnrollmentDisclaimerDialogProps(Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: true }));
	}, [enrollmentDisclaimerDialogProps]);

	const handleCloseDisclaimerDialog = useCallback(() => {
		setEnrollmentDisclaimerDialogProps(Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false }));
	}, [enrollmentDisclaimerDialogProps]);

	const handleEscapeCloseDisclaimerDialog = useCallback(
		(event: React.KeyboardEvent<HTMLInputElement | HTMLDivElement>) => {
			const Key = event.key;

			if (Key === "Escape")
				setEnrollmentDisclaimerDialogProps(
					Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false })
				);
		},
		[enrollmentDisclaimerDialogProps]
	);

	const handleWaiveEnrollment = useCallback(async () => {
		if (member === null || VEBOpenEnrollment === null) {
			return;
		}
		const waiveEnrollmentPromises: any[] = [];
		const accidentWaivePayload = generateCancerKemperWaiveEnrollmentPayload(
			accidentPlan,
			VEB_PLAN_NAME.kemper.accident.standard_accident,
			VEB_PLAN_NAME.kemper.accident.standard_accident,
			null,
			groupOwner,
			member,
			waiveReason,
			VEBOpenEnrollmentId as unknown as string,
			false
		);
		let VEBEnrollmentPayload: VEBEnrollmentPayload = {
			standard_details: accidentWaivePayload.VEBEnrollmentStandardDetails,
			common_details: accidentWaivePayload.VEBEnrollmentCommonDetails,
			isRider: false
		};
		waiveEnrollmentPromises.push(api.enrollment.addVEBEnrollment(VEBEnrollmentPayload));
		const docAndRxPayload = generateCancerKemperWaiveEnrollmentPayload(
			docAndRxPlan,
			VEB_PLAN_NAME.doc_rx.doc_rx.standard_doc_rx,
			VEB_PLAN_NAME.doc_rx.doc_rx.standard_doc_rx,
			null,
			null,
			member,
			waiveReason,
			VEBOpenEnrollmentId as unknown as string,
			false
		);
		VEBEnrollmentPayload = {
			standard_details: docAndRxPayload.VEBEnrollmentStandardDetails,
			common_details: docAndRxPayload.VEBEnrollmentCommonDetails,
			isRider: false
		};
		waiveEnrollmentPromises.push(api.enrollment.addVEBEnrollment(VEBEnrollmentPayload));
		const response = await trackPromise(Promise.all(waiveEnrollmentPromises));
		if (response) {
			deleteCurrentEnrollment();
			getVEBEnrollmentInitData();
			const step = urlSearchParams.get("step");
			const from = urlSearchParams.get("from");
			if (from === "ShortTermDisablity") {
				alert("Succesfully waived Accident");
				history.push(`?step=${from}&stage=1`);
			} else {
				history.push(`?step=${step}&stage=2`);
			}
		}
	}, [
		member,
		VEBOpenEnrollment,
		accidentPlan,
		groupOwner,
		waiveReason,
		VEBOpenEnrollmentId,
		docAndRxPlan,
		deleteCurrentEnrollment,
		getVEBEnrollmentInitData,
		urlSearchParams,
		history
	]);

	const handleWaiveButtonClick = useCallback((): void => {
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Are you sure want to waive this enrollment?",
				textfields: [
					{
						label: "Waive Reason",
						onChange: handleWaiveReasonChange,
						value: waiveReason,
						placeholder: "Enter your reason for waive"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(Object.assign({}, customFormDialogProps, { openDialog: false }))
					},
					{
						label: "Yes",
						callback: () => {
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							);
							handleWaiveEnrollment();
						}
					}
				]
			})
		);
	}, [customFormDialogProps, handleWaiveEnrollment, waiveReason]);

	const handelValidation = useCallback((): boolean => {
		const { coverage, coverage_level, rider_type, rider_benefit_amount } = accidentPlanInputs;

		if (coverage === null || coverage_level === null) {
			alert("Please fill all the required field");
			return false;
		}
		if (hasReadTC === false) {
			alert("Please agree to the Disclaimer");
			return false;
		}
		if (isActivelyWorking === false) {
			alert("You must actively working 20 hours or more to enroll");
			return false;
		}
		return true;
	}, [accidentPlanInputs, hasReadTC, isActivelyWorking]);

	const waitForModalToClose = () =>
		//eslint-disable-next-line
		new Promise<void>((resolve) => {
			const checkModal = () => {
				if (!isDependentExistsModelOpenRef.current) {
					resolve();
				} else {
					setTimeout(checkModal, 1000);
				}
			};
			checkModal();
		});

	const handleActivateButtonCallback = useCallback(async () => {
		const isValid = handelValidation();
		if (isValid === false) {
			return;
		}
		const activateEnrollmentPromise: any[] = [];
		if (member && accidentPlanInputs.coverage && accidentPlan && VEBOpenEnrollment && paycheck) {
			// console.log("cancerPlanInputs", accidentPlanInputs);
			let VEBEnrollments: VEBEnrollments[] = [
				{
					plan: accidentPlan,
					premiumAmount: Number(standardPremium),
					totalPremium: Number((standardPremium + riderPremium).toFixed(2)),
					coverageCode:
						VEB_TO_GENERAL_COVERAGE_CODE[accidentPlanInputs.coverage as keyof VEBToGeneralCoverageCodeType],
					benefitAmount: 0,
					planName: "Accident",
					subPlan: accidentPlanInputs.coverage_level
				}
			];

			if (accidentPlanInputs.rider_type) {
				VEBEnrollments.push({
					plan: accidentPlan,
					premiumAmount: Number(riderPremium),
					totalPremium: Number(riderPremium),
					coverageCode:
						VEB_TO_GENERAL_COVERAGE_CODE[accidentPlanInputs.coverage as keyof VEBToGeneralCoverageCodeType],
					benefitAmount: Number(accidentPlanInputs.rider_benefit_amount as string),
					planName: accidentPlanInputs.rider_type,
					subPlan: null
				});
			}

			const enrollmentSuccessFlag = true;
			const activateStandardEnrollmentPromises: any[] = [];
			const activateRiderEnrollmentPromises: any[] = [];
			let isDependentExistsInOtherEmoloyee = false;
			let standardPayload: any, riderPayload: any;
			VEBEnrollments.forEach(async (VEBEnrollment: VEBEnrollments) => {
				const { plan, premiumAmount, totalPremium, coverageCode, benefitAmount, planName, subPlan } =
					VEBEnrollment;
				const { VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails } =
					generateActivateVEBEnrollmentPayload(
						plan,
						groupOwner,
						member,
						benefitAmount,
						coverageCode,
						premiumAmount,
						planName === accidentPlanInputs.rider_type ? [] : eligibleDependents,
						planName,
						totalPremium,
						"Accident",
						subPlan,
						VEBOpenEnrollmentId as unknown as string,
						paycheck,
						writingNumber
					);
				const VEBEnrollmentPayload: VEBEnrollmentPayload = {
					standard_details: VEBEnrollmentStandardDetails,
					common_details: VEBEnrollmentCommonDetails,
					isRider: hasSelectedRider ? true : false
				};
				if (VEBEnrollmentCommonDetails.base_plan_name === VEBEnrollmentCommonDetails.plan_name) {
					//activateStandardEnrollmentPromises.push(api.enrollment.addVEBEnrollment(VEBEnrollmentPayload));
					standardPayload = VEBEnrollmentPayload;
				} else {
					//activateRiderEnrollmentPromises.push(api.enrollment.addVEBEnrollment(VEBEnrollmentPayload));
					riderPayload = VEBEnrollmentPayload;
				}
			});
			const existEnrollmentData = await trackPromise(api.enrollment.existsVEBEnrollment(standardPayload));

			if (Array.isArray(existEnrollmentData) && existEnrollmentData.length > 0) {
				isDependentExistsInOtherEmoloyee = true;
				setIsDependentExistsModelOpen(true);
				// setExistsDependentData(existEnrollmentData[0].member);
				//eslint-disable-next-line
				setExistsDependentData(existEnrollmentData.map((item) => item.member));
				isDependentExistsModelOpenRef.current = true;
				await waitForModalToClose();
			} else {
				setExistsDependentData(null); // Handle empty case
			}
			if (existEnrollmentData && Array.isArray(existEnrollmentData) && existEnrollmentData.length > 0) {
				const existingSSNs = existEnrollmentData
					//eslint-disable-next-line
					.map((enrollment) => enrollment?.member?.SSN)
					//eslint-disable-next-line
					.filter((ssn) => ssn); // Filter out undefined or null SSNs

				if (existingSSNs.length > 0 && standardPayload.standard_details) {
					standardPayload.standard_details = standardPayload.standard_details.filter(
						(detail: any) => !existingSSNs.includes(detail.member_SSN) && !detail.member_SSN.includes("@")
					);
				}
			}
			if (standardPayload.standard_details && standardPayload.standard_details.length === 1) {
				const { coverage, coverage_level, rider_benefit_amount, rider_type } = accidentPlanInputs;
				const employeeOnlyPremium =
					accidentPlanDetails.premium_amount.standard_premium["Employee Only"][
						coverage_level as keyof AccidentPlanCoverageLevel
					][paycheck.pay_frequency as keyof PaycheckFrequency];
				const totalPremium = employeeOnlyPremium;
				standardPayload.standard_details[0].premium_amount = totalPremium;
				standardPayload.common_details.total_premium = totalPremium;
			}
			VEBEnrollments = [
				{
					plan: docAndRxPlan,
					premiumAmount: docAndRxPremium,
					totalPremium: docAndRxPremium,
					coverageCode:
						VEB_TO_GENERAL_COVERAGE_CODE[accidentPlanInputs.coverage as keyof VEBToGeneralCoverageCodeType],
					benefitAmount: 0,
					planName: "Doc and Rx",
					subPlan: null
				}
			];
			VEBEnrollments.forEach(async (VEBEnrollment: VEBEnrollments) => {
				const { plan, premiumAmount, totalPremium, coverageCode, benefitAmount, planName, subPlan } =
					VEBEnrollment;
				const { VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails } =
					generateActivateVEBEnrollmentPayload(
						plan,
						groupOwner,
						member,
						benefitAmount,
						coverageCode,
						premiumAmount,
						eligibleDependents,
						planName,
						totalPremium,
						"Doc and Rx",
						subPlan,
						VEBOpenEnrollmentId as unknown as string,
						paycheck,
						writingNumber
					);
				const VEBEnrollmentPayload: VEBEnrollmentPayload = {
					standard_details: VEBEnrollmentStandardDetails,
					common_details: VEBEnrollmentCommonDetails,
					isRider: hasSelectedRider ? true : false
				};
				// @casesolving
				if (isDependentExistsInOtherEmoloyee) {
					VEBEnrollmentPayload.standard_details = VEBEnrollmentPayload.standard_details.filter(
						(detail: any) => !detail.member_SSN.includes("@")
					);
				}
				console.log("DOXRSXXXXXXXXXXXXXXXXXXXX----->", VEBEnrollmentPayload);
				// console.log("VEBEnrollmentPayload", VEBEnrollmentPayload);
				activateEnrollmentPromise.push(api.enrollment.addVEBEnrollment(VEBEnrollmentPayload));
				// const response = await api.enrollment.addVEBEnrollment(VEBEnrollmentPayload);
				// if (!response) {
				// 	enrollmentSuccessFlag = false;
				// }
			});
			const standardResponse = await trackPromise(api.enrollment.addVEBEnrollment(standardPayload));
			let riderResponse: any = null;
			if (standardResponse && accidentPlanInputs.rider_type && riderPayload) {
				// console.log("standardResponse", standardResponse);
				riderResponse = await trackPromise(api.enrollment.addVEBEnrollment(riderPayload));
			}

			const response = await trackPromise(Promise.allSettled(activateEnrollmentPromise));
			if (response && standardResponse) {
				deleteCurrentEnrollment();
				getVEBEnrollmentInitData();
				const step = urlSearchParams.get("step");
				const from = urlSearchParams.get("from");
				if (from === "ShortTermDisablity") {
					alert(
						`Succesfully enrolled Accident Plan ${
							accidentPlanInputs.rider_type ? `with ${accidentPlanInputs.rider_type}` : ""
						}`
					);
					history.push(`?step=${from}&stage=1`);
				} else {
					history.push(`?step=${step}&stage=2`);
				}
			}
		}
	}, [
		handelValidation,
		member,
		accidentPlanInputs,
		accidentPlan,
		VEBOpenEnrollment,
		paycheck,
		standardPremium,
		riderPremium,
		docAndRxPlan,
		docAndRxPremium,
		groupOwner,
		eligibleDependents,
		VEBOpenEnrollmentId,
		writingNumber,
		hasSelectedRider,
		deleteCurrentEnrollment,
		getVEBEnrollmentInitData,
		urlSearchParams,
		history
	]);

	useEffect(() => {
		isDependentExistsModelOpenRef.current = isDependentExistsModelOpen;
	}, [isDependentExistsModelOpen]);

	const calculatePremium = useCallback(() => {
		const { coverage, coverage_level, rider_benefit_amount, rider_type } = accidentPlanInputs;
		let standardPremiumAmount = 0;
		let riderPremiumAmount = 0;
		if (coverage && coverage_level && paycheck) {
			standardPremiumAmount =
				accidentPlanDetails.premium_amount.standard_premium[coverage as keyof AccidentPlanCoverage][
					coverage_level as keyof AccidentPlanCoverageLevel
				][paycheck.pay_frequency as keyof PaycheckFrequency];
			setStandardPremium(standardPremiumAmount);
			setDocAndRxPremium(docAndRx.standard_premium[paycheck.pay_frequency as keyof PaycheckFrequency]);
			if (rider_type && rider_benefit_amount && paycheck) {
				const riderPremiumAmountArray =
					riderPlanDetails.standard_premium[rider_type as keyof AccidentRiderPlanCoverage][
						paycheck.pay_frequency as keyof PaycheckFrequency
					];
				const riderPremiumAmountDetails = riderPremiumAmountArray.find(
					(amount: AccidentPremiumBenefit) => amount.coverageAmount === parseInt(rider_benefit_amount)
				);
				riderPremiumAmount =
					riderPremiumAmountDetails !== undefined ? riderPremiumAmountDetails.premiumAmount : 0;
				setRiderPremium(riderPremiumAmount);
				setHasSelectedRider(true);
			} else {
				setRiderPremium(0);
				setHasSelectedRider(false);
			}
			setCurrentEnrollment(
				Object.assign(
					{},
					{
						plan_name: "Accident",
						status: "Current",
						premium_amount: Number(
							(standardPremiumAmount + riderPremiumAmount + docAndRxPremium).toFixed(2)
						)
					}
				)
			);
		}
	}, [
		accidentPlanDetails.premium_amount.standard_premium,
		accidentPlanInputs,
		docAndRx.standard_premium,
		docAndRxPremium,
		paycheck,
		riderPlanDetails.standard_premium,
		setCurrentEnrollment
	]);

	const getShortTermDisablityEnrollment = useCallback(async () => {
		const STDEnrollment: VEBEnrollmentSchema | null = await api.enrollment.getShortTermDisablityEnrollment();
		if (STDEnrollment) {
			setEnrollmentDependencyDialogProps((prevEnrollmentDependencyDialogProps: any) => {
				return Object.assign({}, prevEnrollmentDependencyDialogProps, {
					openDialog: true
				});
			});
			setHasSTDEnrollment(true);
		} else {
			setHasSTDEnrollment(false);
		}
	}, []);

	const getAccidentInitData = useCallback(async () => {
		if (VEBOpenEnrollment === null) {
			return;
		}
		const accidentPlanInitQuery: AccidentPlanInitQuery = {
			VEB_open_enrollment_id: VEBOpenEnrollmentId as unknown as string
		};
		const { shortTermDisablityEnrollment, latestAccidentEnrollment } = await trackPromise(
			api.pages.getAccidentPlanInitData(accidentPlanInitQuery)
		);
		if (shortTermDisablityEnrollment) {
			setEnrollmentDependencyDialogProps((prevEnrollmentDependencyDialogProps: any) => {
				return Object.assign({}, prevEnrollmentDependencyDialogProps, {
					openDialog: true
				});
			});
			setHasSTDEnrollment(true);
		} else {
			setHasSTDEnrollment(false);
		}
		// console.log("latestAccident", latestAccidentEnrollment);
		if (latestAccidentEnrollment) {
			setHasPreviousAccidentEnrollment(true);
			setAccidentSubPlans(Object.assign([], ["Edge Enhanced", "Edge Premier"]));
		} else {
			setHasPreviousAccidentEnrollment(false);
			setAccidentSubPlans(Object.assign([], ["Edge Enhanced", "Edge Premier"]));
		}
	}, [VEBOpenEnrollment, VEBOpenEnrollmentId]);

	const getMaxBenefitAmounts = useCallback(() => {
		if (paycheck) {
			let maxBenefitAmount = 0;
			switch (paycheck.rate_type) {
				case "FLAT RATE": {
					if (paycheck.pay_frequency === "MONTHLY") {
						const annualSalary = paycheck.monthly_base_rate * 12;
						const annualMaxBenefit = annualSalary * 0.6;
						const weeklySalary = annualMaxBenefit / 52;
						maxBenefitAmount = Math.floor(weeklySalary / 50) * 50;
					} else if (paycheck.pay_frequency === "WEEKLY") {
						const annualSalary = paycheck.weekly_base_rate * 52;
						const annualMaxBenefit = annualSalary * 0.6;
						const weeklySalary = annualMaxBenefit / 52;
						maxBenefitAmount = Math.floor(weeklySalary / 100) * 100;
					}
					break;
				}
				case "HOURLY RATE": {
					if (paycheck.pay_frequency === "MONTHLY") {
						const annualSalary = paycheck.hourly_base_pay_rate * 160 * 12;
						const annualMaxBenefit = annualSalary * 0.6;
						const weeklySalary = annualMaxBenefit / 52;
						maxBenefitAmount = Math.floor(weeklySalary / 50) * 50;
					} else if (paycheck.pay_frequency === "WEEKLY") {
						const annualSalary = paycheck.hourly_base_pay_rate * 40 * 52;
						const annualMaxBenefit = annualSalary * 0.6;
						const weeklySalary = annualMaxBenefit / 52;
						// console.log("weekly", weeklySalary);
						maxBenefitAmount = Math.floor(weeklySalary / 100) * 100;
					}
				}
			}
			const _maxBenefitAmounts: number[] = [];
			riderPlanDetails.monthly_benefit.forEach((benefitAmount: number) => {
				if (benefitAmount <= maxBenefitAmount) {
					_maxBenefitAmounts.push(benefitAmount);
				}
			});
			setMaxBenefitAmounts(Object.assign([], _maxBenefitAmounts));
		}
	}, [paycheck, riderPlanDetails.monthly_benefit]);

	useEffect(() => {
		if (VEBOpenEnrollment && VEBOpenEnrollment.length !== 0) {
			getVEBPlanCode(VEBOpenEnrollment);
		}
	}, [VEBOpenEnrollment, getVEBPlanCode]);

	useEffect(() => {
		calculatePremium();
	}, [calculatePremium, accidentPlanInputs]);

	useEffect(() => {
		getMaxBenefitAmounts();
		getAccidentInitData();
		const dependentCoverage = getKemperAccidentEligibleDependents(dependents);
		setEligibleDependents(Object.assign([], dependentCoverage.dependents));
		setAccidentPlanDetails((prevCancerPlanDetails: AccidentPlanDetails) => {
			return Object.assign({}, prevCancerPlanDetails, {
				coverage: dependentCoverage.coverage
			});
		});
		setEligiblityDialogProps((prevEligiblityDialogProps: EligiblityDialogProps) => {
			return Object.assign({}, prevEligiblityDialogProps, {
				openDialog: true,
				eligibleDependents: Object.assign([], dependentCoverage.dependents),
				ineligibleRelationshipDependents: Object.assign([], dependentCoverage.ineligibleRelationshipDependents),
				ineligibleDependents: Object.assign([], dependentCoverage.ineligibleDependents)
			});
		});
		setEligiblity(
			Object.assign(
				{},
				{
					eligibleDependents: Object.assign([], dependentCoverage.dependents),
					ineligibleRelationshipDependents: Object.assign(
						[],
						dependentCoverage.ineligibleRelationshipDependents
					),
					ineligibleDependents: Object.assign([], dependentCoverage.ineligibleDependents)
				}
			)
		);
	}, [dependents, getAccidentInitData, getMaxBenefitAmounts, getShortTermDisablityEnrollment, setEligiblity]);

	// console.log("AccidentInput", accidentSubPlans);

	return (
		<>
			<div className="kemper-cancer-form plan-form">
				<Suspense fallback={<div />}>
					<EligiblityDialog eligiblityDialogProps={eligiblityDialogProps} />
				</Suspense>
				<Suspense fallback={<div />}>
					<CustomEnrollmentDisclaimerDialog
						enrollmentDisclaimerDialogProps={enrollmentDisclaimerDialogProps}
						handleCloseDisclaimerDialog={handleCloseDisclaimerDialog}
						handleEscapeCloseDisclaimerDialog={handleEscapeCloseDisclaimerDialog}
						emailDisclaimer={emailDisclaimer}
						setEmailDisclaimer={setEmailDisclaimer}
					/>
				</Suspense>
				<Suspense fallback={<div />}>
					<EnrollmentDependencyDialog dialogProps={enrollmentDependencyDialogProps} />
				</Suspense>
				<Suspense fallback={<div />}>
					{customFormDialogProps ? (
						<LazyCustomFormDialog customFormDialogProps={customFormDialogProps} />
					) : null}
				</Suspense>
				<div className="paper-form-container">
					<Paper className="theme-border-radius paper-container" elevation={1}>
						<VEBPlanHeader
							planName="MedMutual Protect  Accident Insurance Policy"
							effectiveDate={
								planCode
									? planCode === "AI-ALL-2024"
										? VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_MMDDYYYY
										: VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_MMDDYYYY
									: "N/A"
							}
							planCode={planCode ? (planCode as unknown as string) : "No Plan is Opened"}
						/>
						<div className="plan-content">
							<div className="theme-plan-section-margin" />
							<div className="header-container header-container-new">
								<div className="theme-plan-header">Standard Benefits</div>
							</div>
							<div>
								<div
									className="theme-plan-sub-header plan-text"
									style={{ borderLeftColor: theme.primary_color }}
								>
									In addition to yourself, who would you like to cover under this plan?
								</div>
								<Grid className="grid-container" container columnSpacing={2}>
									<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
										<div className="details-form-row">
											<div className="details-form-label  required">Coverage For</div>
											<Select
												input={<CustomSelectInput />}
												style={{ width: "100%" }}
												name="coverage"
												onChange={(event: SelectChangeEvent) => handleAccidentFormChange(event)}
											>
												{accidentPlanDetails.coverage.map((coverage: string, index: number) => {
													return (
														<MenuItem value={coverage} key={index}>
															{initCapitalize(coverage)}
														</MenuItem>
													);
												})}
											</Select>
										</div>
									</Grid>
									<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
										<div className="details-form-row">
											<div className="details-form-label  required">Coverage Level</div>
											<Select
												input={<CustomSelectInput />}
												style={{ width: "100%" }}
												name="coverage_level"
												onChange={(event: SelectChangeEvent) => handleAccidentFormChange(event)}
											>
												{accidentSubPlans.map((accidentSubPlan: string, index: number) => {
													return (
														<MenuItem value={accidentSubPlan} key={index}>
															{accidentSubPlan}
														</MenuItem>
													);
												})}
											</Select>
										</div>
									</Grid>
									<Grid item xl={2} lg={2} md={2} sm={2} xs={6}>
										<div className="details-form-row">
											<div className="details-form-label required align-center">Premium</div>
											<div className="show-premium">{dollarize(standardPremium)}</div>
										</div>
									</Grid>
								</Grid>
							</div>
						</div>

						<div className="plan-content">
							<div className="theme-plan-section-margin" />
							<div className="header-container header-container-new">
								<div className="theme-plan-header">Rider Benefits</div>
							</div>
							<Tooltip
								title={
									hasSTDEnrollment
										? "You are ineligible for Accident Disablity Riders as you have already enrolled for Kemper Short Term Disablity"
										: ""
								}
							>
								<div>
									<div
										className="theme-plan-sub-header plan-text"
										style={{
											borderLeftColor: theme.primary_color,
											cursor: hasSTDEnrollment ? "not-allowed" : "inherit"
										}}
									>
										Disability income rider rates
									</div>
									<Grid className="grid-container" container columnSpacing={2}>
										<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
											<div className="details-form-row">
												<div className="details-form-label  required">
													Disability income rider type
												</div>
												<Select
													input={<CustomSelectInput />}
													style={{
														width: "100%",
														cursor: hasSTDEnrollment ? "not-allowed" : "inherit"
													}}
													name="rider_type"
													onChange={(event: SelectChangeEvent) =>
														handleAccidentFormChange(event)
													}
													disabled={hasSTDEnrollment ? true : false}
												>
													<MenuItem value={""} className="empty-option"></MenuItem>
													<MenuItem value={"Accident Only"}>Accident Only</MenuItem>
													<MenuItem value={"Accident and Sickness"}>
														Accident and Sickness
													</MenuItem>
												</Select>
											</div>
										</Grid>
										<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
											<div className="details-form-row">
												<div className="details-form-label  required">
													Monthly disability benefit
												</div>
												<Select
													input={<CustomSelectInput />}
													style={{
														width: "100%",
														cursor: hasSTDEnrollment ? "not-allowed" : "inherit"
													}}
													name="rider_benefit_amount"
													disabled={hasSTDEnrollment ? true : false}
													onChange={(event: SelectChangeEvent) =>
														handleAccidentFormChange(event)
													}
												>
													<MenuItem value={0} className="empty-option"></MenuItem>
													{maxBenefitAmounts.map((benefitAmount: number, index: number) => {
														return (
															<MenuItem value={benefitAmount} key={index}>
																{dollarize(benefitAmount)}
															</MenuItem>
														);
													})}
												</Select>
											</div>
										</Grid>
										<Grid item xl={2} lg={2} md={2} sm={2} xs={6} className="">
											<div className="details-form-row">
												<div className="details-form-label required align-center">Premium</div>
												<div className="show-premium">{dollarize(riderPremium)}</div>
											</div>
										</Grid>
									</Grid>
								</div>
							</Tooltip>
							<div>
								<div
									className="theme-plan-sub-header plan-text"
									style={{ borderLeftColor: theme.primary_color }}
								>
									Doc & Rx
								</div>
								<Grid className="grid-container" container columnSpacing={2}>
									<Grid item xl={10} lg={10} md={10} sm={10} xs={6} className="margin-adjust-33">
										<label className="details-form-label required">Doctor & RX</label>
									</Grid>
									<Grid item xl={2} lg={2} md={2} sm={2} xs={6}>
										<div className="details-form-row">
											<div className="details-form-label required align-center">Premium</div>
											<div className="show-premium">{dollarize(docAndRxPremium)}</div>
										</div>
									</Grid>
								</Grid>
							</div>
						</div>
						<div className="theme-plan-inner-section-margin" />
						<Grid container className="theme-plan-inner-section-margin">
							<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
								<div className="details-form-row">
									<div
										className="details-form-label theme-plan-total-premium align-right"
										style={{ color: theme.primary_color }}
									>
										Total Premium:{" "}
										<span className="show-premium margin-adjust">
											{dollarize(standardPremium + riderPremium + docAndRxPremium)}
										</span>
									</div>
								</div>
							</Grid>
						</Grid>
						{!VEBPlanCodes2024.includes(planCode as unknown as string) ? (
							<div className="veb-disclaimer">{/* <VEBDisclaimer /> */}</div>
						) : null}
						<div className="theme-plan-option-content">
							<Checkbox
								checked={isActivelyWorking}
								style={{ paddingLeft: 0 }}
								onChange={handleIsActivelyWorkingCheckboxChange}
							/>
							<p className="theme-plan-checkbox-label">
								<strong>Are you actively at work 20 or more hours per week?</strong>
							</p>
						</div>
						<div>
							<div className="theme-plan-option-content">
								<Checkbox
									checked={hasReadTC}
									style={{ paddingLeft: 0 }}
									onChange={handleAgreedTCCheckboxChange}
								/>
								<p className="theme-plan-checkbox-label">
									<strong>
										I have read the{" "}
										<span
											className="veb-plan-disclaimer"
											style={{ color: theme.primary_color }}
											onClick={handleOpenDisclaimerDialogClick}
										>
											Disclaimer
										</span>
									</strong>
								</p>
							</div>
						</div>
						<div className="theme-plan-inner-section-margin-2" />
						{/* <Grid container>
						<Grid item xl={4} lg={4} md={4} sm={10} xs={10} columnSpacing={2}>
							<div className="details-form-row">
								<div className="details-form-label required">Writing Number</div>
								<Grid container>
									<Grid item xl={9}>
										<CustomInput value={writingNumber} onChange={handleWritingNumberChange} />
									</Grid>
									{showWritingNumberValidateButton ? (
										<Grid item xl={3}>
											<div className="writing-number-validate-container">
												<Button
													style={{
														backgroundColor: theme.button.background_color,
														color: theme.button.color,
														opacity: 0.8
													}}
												>
													Validate
												</Button>
											</div>
										</Grid>
									) : null}
								</Grid>
							</div>
						</Grid>
					</Grid> */}
						<div className="theme-plan-inner-section-margin-2" />
						<LazyPlanActions
							waiveButtonCallback={handleWaiveButtonClick}
							activateButtonCallback={handleActivateButtonCallback}
						/>
					</Paper>
				</div>
			</div>
			{isDependentExistsModelOpen && (
				<ExistsDependentModelVEB
					onClose={() => setIsDependentExistsModelOpen(false)}
					dependentData={existsDependentData}
				/>
			)}
		</>
	);
};

export default KemperAccidentForm;
